//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingPeriodController_findOneById,
  Response$AdminBillingPeriodController_findOneById$Status$200,
  ResponseContentType$AdminBillingPeriodController_findOneById,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBillingPeriodController_findOneById = (options: {
  params: Params$AdminBillingPeriodController_findOneById['parameter'];
  config?: QueryOptions<
    Response$AdminBillingPeriodController_findOneById$Status$200[ResponseContentType$AdminBillingPeriodController_findOneById]
  >;
}) =>
  useApiClient<
    Params$AdminBillingPeriodController_findOneById,
    Response$AdminBillingPeriodController_findOneById$Status$200[ResponseContentType$AdminBillingPeriodController_findOneById]
  >({
    method: 'AdminBillingPeriodController_findOneById',
    params: { parameter: options.params },
    config: options.config,
  });
